var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPiechart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12.384,
    height: 12.381,
    viewBox: "0 0 12.384 12.381",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "pie-chart_5782659",
    transform: "translate(0 -0.054)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_374949",
    "data-name": "Path 374949",
    d: "M275.585,5.781h4.638A.727.727,0,0,0,280.947,5,5.379,5.379,0,0,0,276,.056a.727.727,0,0,0-.782.724V5.418a.363.363,0,0,0,.363.363Z",
    transform: "translate(-268.565)",
    fill: "#125bb2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_374950",
    "data-name": "Path 374950",
    d: "M280.2,266.963h-4.638a.363.363,0,0,0-.26.615l3.229,3.329a.726.726,0,0,0,1.065-.024,5.326,5.326,0,0,0,1.329-3.139A.727.727,0,0,0,280.2,266.963Z",
    transform: "translate(-268.546 -260.453)",
    fill: "#125bb2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_374951",
    "data-name": "Path 374951",
    d: "M5.741,73.4V68.547a.727.727,0,0,0-.784-.724,5.379,5.379,0,0,0,.355,10.74h.067a5.332,5.332,0,0,0,3.173-1.036.727.727,0,0,0,.1-1.088Z",
    transform: "translate(0 -66.128)",
    fill: "#125bb2"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPiechart);
export default __webpack_public_path__ + "static/media/piechart.aa326a699e299038bdfbae3f6a405924.svg";
export { ForwardRef as ReactComponent };